module.exports = __webpack_public_path__ + "static/media/fun.e1a41f32.mp3";